import { defineField, defineType } from 'sanity'
import { strongEmLink } from '../../data/richText'

export default defineType({
  name: 'promotionModal',
  title: 'Modal',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Description',
      name: 'description',
      type: 'array',
      of: strongEmLink,
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({ title = 'New Modal' }) {
      return {
        title,
      }
    },
  },
})